import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import { DialogActions } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import PropTypes from 'prop-types';
import Checkmark from 'Icons/Checkmark';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';

const useStyles = buildUseStyles('FeedbackAdditionalDetailsCompletedContent', ((theme) => ({
  root: {},
  title: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: theme.spacing(2),
    paddingTop: theme.spacing(4),
  },
  content: {
    height: 98,
  },
  iconContainer: {
    background: theme.palette.facet.accentBlue21,
    borderRadius: theme.radius.full,
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'center',
  },
})));

const FeedbackAdditionalDetailsCompletedContent = ({ onClose }) => {
  const classes = useStyles();
  return <>
    <DialogTitle>
      <Box className={classes.title}>
        <Box className={classes.iconContainer}>
          <Icon boxSize={'lg'} icon={Checkmark} fill={'none'} stroke={'primary'} />
        </Box>
        <Title text={'Thank you'} />
      </Box>
    </DialogTitle>
    <DialogContent className={classes.content}>
      <Subtitle text={'Your response has been submitted and will be reviewed by our team.'} />
      <Subtitle text={'Your feedback is invaluable to Facet as we strive to provide you with the best experience possible.'} />
    </DialogContent>
    <DialogActions className={classes.dialogActions}>
      <RoundedButton
        onClick={() => onClose()}
        variant={'contained'}
        color={'primary'}
        fullWidth
        size={DS_SIZE_MAP.sm}
      >
          Close
      </RoundedButton>
    </DialogActions>
  </>;
};

FeedbackAdditionalDetailsCompletedContent.defaultProps = {
  onClose: undefined,
};

FeedbackAdditionalDetailsCompletedContent.propTypes = {
  onClose: PropTypes.func,
};

export default FeedbackAdditionalDetailsCompletedContent;
